<script>
export default {
  props: ["clr", "strokeWidth", "backClr"]
};
</script>
<template>
  <svg
    id="favorite"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path id="Path_7712" data-name="Path 7712" d="M0,0H24V24H0Z" fill="none" />
    <path
      id="Path_7713"
      data-name="Path 7713"
      d="M7.733,20.829h0a1.5,1.5,0,0,1-2.171-1.592L6.371,14.6,2.965,11.336h0a1.5,1.5,0,0,1,.827-2.571l4.729-.676L10.656,3.83h0a1.5,1.5,0,0,1,2.688,0l2.135,4.259,4.729.676h0a1.5,1.5,0,0,1,.827,2.571L17.629,14.6l.809,4.638h0a1.5,1.5,0,0,1-2.171,1.592L12,18.625Z"
      transform="translate(0 0)"
      :fill="backClr ? backClr : '#fff'"
      :stroke="clr ? clr : '#ccc'"
      stroke-linecap="round"
      stroke-linejoin="round"
      :stroke-width="strokeWidth ? strokeWidth : 1.5"
    />
  </svg>
</template>
